import React, {useEffect, useRef, useState} from "react"
import NavigationMenuItem from "../../../menu-items/menu-item";
import NavigationMenu_PersonalViewsMorePopover from "./more-popover";
import {findDOMNode} from "react-dom";
import {BUS_ON_PERSONAL_EVENT_LOCATION_CHANGE} from "../../../../../core/model2/view/personal-view/@const";
import {useForceUpdate} from "../../../../../core/gd/utils/dom-and-react/react-utils"
import {BUS_APP_LAUNCH} from "../../../../../core/gd/app-manager/@event"

type Props = {
    className?              : string
}

// const debug = "NavigationMenuNewView"
const debug = false

export default function NavigationMenu_PersonalViewsMore(props:Props) {

    const selfRef:any                   = useRef()
    const [showPopover, setShowPopover] = useState(false)

    const forceUpdate = useForceUpdate()

    useEffect(() => {
        const unsubscribe           = gd.bus.subscribeNoContext(BUS_ON_PERSONAL_EVENT_LOCATION_CHANGE, hidePopover)
        const unsubscribeLaunchApp  = gd.bus.subscribeNoContext(BUS_APP_LAUNCH, onLaunchApp)
        return () => {
            unsubscribe()
            unsubscribeLaunchApp()
        }
    }, [])

    const togglePopover = () => {
        setShowPopover(!showPopover)
    }

    const hidePopover = () => {
        setShowPopover(false)
    }

    const onLaunchApp = () => {
        forceUpdate()
    }

    debug && console.log(debug, 'render')

    return (
        <NavigationMenuItem ref         = {selfRef}
                            icon        = "i5-long-arrow-down"
                            name        = "More"
                            selected    = {gd.user.personalViews.isMoreViewSelected}
                            onClick     = {togglePopover} >
            {showPopover &&
                <NavigationMenu_PersonalViewsMorePopover parentRef      = {selfRef}
                                                         getTargetFunc  = {()=>findDOMNode(selfRef.current)}
                                                         hidePopover    = {hidePopover}/>
            }
        </NavigationMenuItem>
    )

}